import { createLogger, serializeError } from 'logging';

import { SearchContentClass, typeaheadEndpoint } from '../StockblocksClient';
import { TypeaheadData } from './TypeaheadData';

const logger = createLogger('fetchTypeahead');

export const fetchTypeahead = async (
    contentClass: SearchContentClass,
    keywords: string = '',
): Promise<TypeaheadData> => {
    try {
        if (!contentClass) {
            // @ts-expect-error suppressing this error as part of the ESLint strictness migration.
            return new Response('Missing contentClass', { status: 400 });
        }

        const result = await typeaheadEndpoint(contentClass, { keywords: keywords || '' });
        return result?.data;
    } catch (e) {
        logger.error({ err: serializeError(e) }, `Error fetching typeahead suggestions`);
        return {
            collections: [],
            keywords: [],
            latestCollections: [],
            relatedContentTypesAndKeywords: [],
            message: '',
        } satisfies TypeaheadData;
    }
};
